"use client";

import { c as _c } from "react/compiler-runtime";
import GridColumn from "@/components/common/grid-column/grid-column";
import GridRow from "@/components/common/grid-row/grid-row";
import SuperTitle from "@/components/common/supertitle/supertitle";
import ProductArticleCard from "@/components/products/product/product-articles/product-article-card/product-article-card";
import usePagination from "@/hooks/usePagination";
import { ArticleData } from "@/sanity/interfaces";
import { ArticleCategory } from "@/sanity/sanity.types";
import { mapArticleInfo } from "@/utilities/resources";
import Pagination from "@/components/common/pagination/Pagination";
import { ARTICLES_PER_PAGE } from "@/sanity/constants";
import { usePerformance } from "@/contexts/performance-context";
import { useEffect } from "react";
interface IResourceCategoryProps {
  articles: ArticleData[];
  articleCount: number;
  category: ArticleCategory;
  categorySlug: string;
  currentPage: number;
  beforeParamTime: number;
  beforeQueryTime: number;
  afterQueryTime: number;
  name?: string;
  description?: string;
  type?: string;
}
const ResourceCategory = props => {
  const $ = _c(33);
  const {
    articles,
    articleCount,
    categorySlug,
    currentPage,
    beforeParamTime,
    beforeQueryTime,
    afterQueryTime,
    name,
    description,
    type
  } = props;
  const {
    checkTimeElapsed
  } = usePerformance();
  let t0;
  if ($[0] !== articleCount || $[1] !== currentPage) {
    t0 = {
      initialItemsPerPage: ARTICLES_PER_PAGE,
      initialPage: currentPage,
      totalItems: articleCount
    };
    $[0] = articleCount;
    $[1] = currentPage;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const {
    totalPages
  } = usePagination(t0);
  const articleInfo = mapArticleInfo(articles);
  const basePath = `/learn/${type}/${categorySlug}`;
  let t1;
  if ($[3] !== basePath) {
    t1 = page => {
      if (page <= 1) {
        return basePath;
      }
      return `${basePath}?page=${page}`;
    };
    $[3] = basePath;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const getPageHref = t1;
  let t2;
  if ($[5] !== afterQueryTime || $[6] !== beforeParamTime || $[7] !== beforeQueryTime || $[8] !== checkTimeElapsed) {
    t2 = () => {
      checkTimeElapsed(beforeParamTime, "Resource category page before param started");
      checkTimeElapsed(beforeQueryTime, "Resource category page before query started");
      checkTimeElapsed(afterQueryTime, "Resource category page after query completed");
    };
    $[5] = afterQueryTime;
    $[6] = beforeParamTime;
    $[7] = beforeQueryTime;
    $[8] = checkTimeElapsed;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  useEffect(t2, t3);
  const t4 = "my-12 flex flex-col gap-10 lg:gap-[50px]";
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SuperTitle className="m-auto mb-4">Resource Center</SuperTitle>;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== description || $[13] !== name) {
    t6 = name && <><h1>{name}</h1>{description && <div className="color-[#4A4A4A] m-auto mt-4 text-lg font-medium leading-[1.625rem] md:w-[60%]"><p>{description}</p></div>}</>;
    $[12] = description;
    $[13] = name;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t6) {
    t7 = <GridRow><GridColumn center={true} className="">{t5}{t6}</GridColumn></GridRow>;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const T0 = GridRow;
  const T1 = GridColumn;
  const t8 = 12;
  const t9 = "grid md:gap-8 lg:grid-cols-3";
  const t10 = articleInfo.map(_temp);
  let t11;
  if ($[17] !== t10) {
    t11 = <div className={t9}>{t10}</div>;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== T1 || $[20] !== t11) {
    t12 = <T1 lg={t8}>{t11}</T1>;
    $[19] = T1;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== T0 || $[23] !== t12) {
    t13 = <T0>{t12}</T0>;
    $[22] = T0;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== currentPage || $[26] !== getPageHref || $[27] !== totalPages) {
    t14 = <GridRow><GridColumn><Pagination currentPage={currentPage} totalPages={totalPages} getPageHref={getPageHref} /></GridColumn></GridRow>;
    $[25] = currentPage;
    $[26] = getPageHref;
    $[27] = totalPages;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t13 || $[30] !== t14 || $[31] !== t7) {
    t15 = <div className={t4}>{t7}{t13}{t14}</div>;
    $[29] = t13;
    $[30] = t14;
    $[31] = t7;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  return t15;
};
export default ResourceCategory;
function _temp(article, index) {
  return <ProductArticleCard key={index} articleUrl={article.articleUrl} articleUrlText={article.articleUrlText} category={article.category} description={article.description} imageUrl={article.imageUrl} title={article.title} readMinutes={article.readMinutes} categoryFrom="resource-category" updatedDate={article.updatedDate} />;
}